export const green = {
    30: "#F0F9F4",
    40: "#B3F4CD",
    50: "#72E9A1",
    60: "#44C577",
    70: "#14B855",
    80: "#009A3D",
    90: "#007A30",
    100: "#005722",
};
